import { default as index9CXqD4uTYaMeta } from "/opt/buildhome/repo/pages/auditoria/index.vue?macro=true";
import { default as loginNK60uVWHtUMeta } from "/opt/buildhome/repo/pages/autenticacao/login.vue?macro=true";
import { default as recuperar_45acessomi1z5wdBp6Meta } from "/opt/buildhome/repo/pages/autenticacao/recuperar-acesso.vue?macro=true";
import { default as _91token_93xM00u7i80aMeta } from "/opt/buildhome/repo/pages/autenticacao/trocar-senha/[email]/[token].vue?macro=true";
import { default as index9pDu3tk836Meta } from "/opt/buildhome/repo/pages/baixa-de-exames/index.vue?macro=true";
import { default as _91id_93UjgBYe2x3KMeta } from "/opt/buildhome/repo/pages/categorias-de-exames/alteracao/[id].vue?macro=true";
import { default as cadastrou4cWpXAO8cMeta } from "/opt/buildhome/repo/pages/categorias-de-exames/cadastro.vue?macro=true";
import { default as indexziOI8IwodrMeta } from "/opt/buildhome/repo/pages/categorias-de-exames/index.vue?macro=true";
import { default as _91id_93RG6yTqwGgZMeta } from "/opt/buildhome/repo/pages/categorias-de-materiais/alteracao/[id].vue?macro=true";
import { default as cadastroykWxkkxImXMeta } from "/opt/buildhome/repo/pages/categorias-de-materiais/cadastro.vue?macro=true";
import { default as indexP6UC4cgrz4Meta } from "/opt/buildhome/repo/pages/categorias-de-materiais/index.vue?macro=true";
import { default as indexP00IrjAIc9Meta } from "/opt/buildhome/repo/pages/configuracao/index.vue?macro=true";
import { default as indexbI1Frn8FgaMeta } from "/opt/buildhome/repo/pages/dispensacao-de-materiais/index.vue?macro=true";
import { default as nova_45dispensacao6JiT52hiyKMeta } from "/opt/buildhome/repo/pages/dispensacao-de-materiais/nova-dispensacao.vue?macro=true";
import { default as indexyozOxF5mlSMeta } from "/opt/buildhome/repo/pages/emitir-guia-de-exames/index.vue?macro=true";
import { default as index9vmmfV6bwsMeta } from "/opt/buildhome/repo/pages/entrada-de-materiais/index.vue?macro=true";
import { default as nova_45entradafnxban9NQVMeta } from "/opt/buildhome/repo/pages/entrada-de-materiais/nova-entrada.vue?macro=true";
import { default as _91id_93adHz4MhA2uMeta } from "/opt/buildhome/repo/pages/exames/alteracao/[id].vue?macro=true";
import { default as cadastroWBn9S2vhMYMeta } from "/opt/buildhome/repo/pages/exames/cadastro.vue?macro=true";
import { default as indexhCXvGcN4UaMeta } from "/opt/buildhome/repo/pages/exames/index.vue?macro=true";
import { default as _91categoria_93yHbg8CLBZYMeta } from "/opt/buildhome/repo/pages/exames/por-categoria/[categoria].vue?macro=true";
import { default as _91id_93KktXbnEv4EMeta } from "/opt/buildhome/repo/pages/fornecedores/alteracao/[id].vue?macro=true";
import { default as cadastroz74fvs7IDFMeta } from "/opt/buildhome/repo/pages/fornecedores/cadastro.vue?macro=true";
import { default as indexPRIS4gOa4DMeta } from "/opt/buildhome/repo/pages/fornecedores/index.vue?macro=true";
import { default as _91id_93JSziduNObqMeta } from "/opt/buildhome/repo/pages/funcoes/alteracao/[id].vue?macro=true";
import { default as cadastrox0hzuIXObsMeta } from "/opt/buildhome/repo/pages/funcoes/cadastro.vue?macro=true";
import { default as index84J9OY2pqdMeta } from "/opt/buildhome/repo/pages/funcoes/index.vue?macro=true";
import { default as indexwT1xCr0TuOMeta } from "/opt/buildhome/repo/pages/gerenciar-estoque/index.vue?macro=true";
import { default as indexniDiYCWjuTMeta } from "/opt/buildhome/repo/pages/index.vue?macro=true";
import { default as indexmOLpqkzYT7Meta } from "/opt/buildhome/repo/pages/liberacao-de-exames/index.vue?macro=true";
import { default as _91id_93kdnSCYCUJ4Meta } from "/opt/buildhome/repo/pages/materiais/alteracao/[id].vue?macro=true";
import { default as cadastrotAM87ZAJziMeta } from "/opt/buildhome/repo/pages/materiais/cadastro.vue?macro=true";
import { default as indexQybCB9a9LQMeta } from "/opt/buildhome/repo/pages/materiais/index.vue?macro=true";
import { default as _91id_93Xet1u3s5jIMeta } from "/opt/buildhome/repo/pages/medicos/alteracao/[id].vue?macro=true";
import { default as cadastroMxTSQLnK8UMeta } from "/opt/buildhome/repo/pages/medicos/cadastro.vue?macro=true";
import { default as indexW9o7jSLWaYMeta } from "/opt/buildhome/repo/pages/medicos/index.vue?macro=true";
import { default as _91id_93CALT9J3AWjMeta } from "/opt/buildhome/repo/pages/pacientes/alteracao/[id].vue?macro=true";
import { default as cadastro5iOlbfBY00Meta } from "/opt/buildhome/repo/pages/pacientes/cadastro.vue?macro=true";
import { default as indexCPUJtqEjFHMeta } from "/opt/buildhome/repo/pages/pacientes/index.vue?macro=true";
import { default as _91id_93cxnaEKkCy2Meta } from "/opt/buildhome/repo/pages/programas/alteracao/[id].vue?macro=true";
import { default as cadastroIVQoiJTJBDMeta } from "/opt/buildhome/repo/pages/programas/cadastro.vue?macro=true";
import { default as indexlvytRUSfTgMeta } from "/opt/buildhome/repo/pages/programas/index.vue?macro=true";
import { default as examesFkgIdDrvv6Meta } from "/opt/buildhome/repo/pages/relatorios/exames.vue?macro=true";
import { default as historico_45do_45pacientejVcuLBjescMeta } from "/opt/buildhome/repo/pages/relatorios/historico-do-paciente.vue?macro=true";
import { default as log_45acoes_45do_45usuario5YH6nwnxqvMeta } from "/opt/buildhome/repo/pages/relatorios/log-acoes-do-usuario.vue?macro=true";
import { default as indexA0VPeroZ6FMeta } from "/opt/buildhome/repo/pages/solicitacoes-de-exames/index.vue?macro=true";
import { default as novae4aRbU80uhMeta } from "/opt/buildhome/repo/pages/solicitacoes-de-exames/nova.vue?macro=true";
import { default as old_gerenciahKUd9GBye4Meta } from "/opt/buildhome/repo/pages/solicitacoes-de-exames/old_gerencia.vue?macro=true";
import { default as _91id_93T01U1W3gg5Meta } from "/opt/buildhome/repo/pages/solicitacoes-de-exames/old_gerenciar/[id].vue?macro=true";
import { default as index3VTqskQBowMeta } from "/opt/buildhome/repo/pages/transferencia-de-materiais/index.vue?macro=true";
import { default as nova_45transferenciaX1TPUx1X2vMeta } from "/opt/buildhome/repo/pages/transferencia-de-materiais/nova-transferencia.vue?macro=true";
import { default as _91situacao_93Da26bWbqdPMeta } from "/opt/buildhome/repo/pages/transferencia-de-materiais/por-situacao/[situacao].vue?macro=true";
import { default as _91id_93ONK0M37MY1Meta } from "/opt/buildhome/repo/pages/unidades-de-materiais/alteracao/[id].vue?macro=true";
import { default as cadastroJu80IlOM9CMeta } from "/opt/buildhome/repo/pages/unidades-de-materiais/cadastro.vue?macro=true";
import { default as indexXfL2oT74KGMeta } from "/opt/buildhome/repo/pages/unidades-de-materiais/index.vue?macro=true";
import { default as _91id_9311TPqFmMvlMeta } from "/opt/buildhome/repo/pages/unidades-medicas/alteracao/[id].vue?macro=true";
import { default as cadastrom74EvGEjNwMeta } from "/opt/buildhome/repo/pages/unidades-medicas/cadastro.vue?macro=true";
import { default as indexXRm9hNsHyZMeta } from "/opt/buildhome/repo/pages/unidades-medicas/index.vue?macro=true";
import { default as _91id_938tjudblfUbMeta } from "/opt/buildhome/repo/pages/usuarios/alteracao/[id].vue?macro=true";
import { default as alterar_45dados_45de_45acessoLqwh1HZbzKMeta } from "/opt/buildhome/repo/pages/usuarios/alterar-dados-de-acesso.vue?macro=true";
import { default as alterar_45meus_45dadosGsBABu4vyOMeta } from "/opt/buildhome/repo/pages/usuarios/alterar-meus-dados.vue?macro=true";
import { default as cadastro1cqvz05gobMeta } from "/opt/buildhome/repo/pages/usuarios/cadastro.vue?macro=true";
import { default as indexJvDD2TXhs0Meta } from "/opt/buildhome/repo/pages/usuarios/index.vue?macro=true";
export default [
  {
    name: index9CXqD4uTYaMeta?.name ?? "auditoria",
    path: index9CXqD4uTYaMeta?.path ?? "/auditoria",
    meta: index9CXqD4uTYaMeta || {},
    alias: index9CXqD4uTYaMeta?.alias || [],
    redirect: index9CXqD4uTYaMeta?.redirect || undefined,
    component: () => import("/opt/buildhome/repo/pages/auditoria/index.vue").then(m => m.default || m)
  },
  {
    name: loginNK60uVWHtUMeta?.name ?? "autenticacao-login",
    path: loginNK60uVWHtUMeta?.path ?? "/autenticacao/login",
    meta: loginNK60uVWHtUMeta || {},
    alias: loginNK60uVWHtUMeta?.alias || [],
    redirect: loginNK60uVWHtUMeta?.redirect || undefined,
    component: () => import("/opt/buildhome/repo/pages/autenticacao/login.vue").then(m => m.default || m)
  },
  {
    name: recuperar_45acessomi1z5wdBp6Meta?.name ?? "autenticacao-recuperar-acesso",
    path: recuperar_45acessomi1z5wdBp6Meta?.path ?? "/autenticacao/recuperar-acesso",
    meta: recuperar_45acessomi1z5wdBp6Meta || {},
    alias: recuperar_45acessomi1z5wdBp6Meta?.alias || [],
    redirect: recuperar_45acessomi1z5wdBp6Meta?.redirect || undefined,
    component: () => import("/opt/buildhome/repo/pages/autenticacao/recuperar-acesso.vue").then(m => m.default || m)
  },
  {
    name: _91token_93xM00u7i80aMeta?.name ?? "autenticacao-trocar-senha-email-token",
    path: _91token_93xM00u7i80aMeta?.path ?? "/autenticacao/trocar-senha/:email()/:token()",
    meta: _91token_93xM00u7i80aMeta || {},
    alias: _91token_93xM00u7i80aMeta?.alias || [],
    redirect: _91token_93xM00u7i80aMeta?.redirect || undefined,
    component: () => import("/opt/buildhome/repo/pages/autenticacao/trocar-senha/[email]/[token].vue").then(m => m.default || m)
  },
  {
    name: index9pDu3tk836Meta?.name ?? "baixa-de-exames",
    path: index9pDu3tk836Meta?.path ?? "/baixa-de-exames",
    meta: index9pDu3tk836Meta || {},
    alias: index9pDu3tk836Meta?.alias || [],
    redirect: index9pDu3tk836Meta?.redirect || undefined,
    component: () => import("/opt/buildhome/repo/pages/baixa-de-exames/index.vue").then(m => m.default || m)
  },
  {
    name: _91id_93UjgBYe2x3KMeta?.name ?? "categorias-de-exames-alteracao-id",
    path: _91id_93UjgBYe2x3KMeta?.path ?? "/categorias-de-exames/alteracao/:id()",
    meta: _91id_93UjgBYe2x3KMeta || {},
    alias: _91id_93UjgBYe2x3KMeta?.alias || [],
    redirect: _91id_93UjgBYe2x3KMeta?.redirect || undefined,
    component: () => import("/opt/buildhome/repo/pages/categorias-de-exames/alteracao/[id].vue").then(m => m.default || m)
  },
  {
    name: cadastrou4cWpXAO8cMeta?.name ?? "categorias-de-exames-cadastro",
    path: cadastrou4cWpXAO8cMeta?.path ?? "/categorias-de-exames/cadastro",
    meta: cadastrou4cWpXAO8cMeta || {},
    alias: cadastrou4cWpXAO8cMeta?.alias || [],
    redirect: cadastrou4cWpXAO8cMeta?.redirect || undefined,
    component: () => import("/opt/buildhome/repo/pages/categorias-de-exames/cadastro.vue").then(m => m.default || m)
  },
  {
    name: indexziOI8IwodrMeta?.name ?? "categorias-de-exames",
    path: indexziOI8IwodrMeta?.path ?? "/categorias-de-exames",
    meta: indexziOI8IwodrMeta || {},
    alias: indexziOI8IwodrMeta?.alias || [],
    redirect: indexziOI8IwodrMeta?.redirect || undefined,
    component: () => import("/opt/buildhome/repo/pages/categorias-de-exames/index.vue").then(m => m.default || m)
  },
  {
    name: _91id_93RG6yTqwGgZMeta?.name ?? "categorias-de-materiais-alteracao-id",
    path: _91id_93RG6yTqwGgZMeta?.path ?? "/categorias-de-materiais/alteracao/:id()",
    meta: _91id_93RG6yTqwGgZMeta || {},
    alias: _91id_93RG6yTqwGgZMeta?.alias || [],
    redirect: _91id_93RG6yTqwGgZMeta?.redirect || undefined,
    component: () => import("/opt/buildhome/repo/pages/categorias-de-materiais/alteracao/[id].vue").then(m => m.default || m)
  },
  {
    name: cadastroykWxkkxImXMeta?.name ?? "categorias-de-materiais-cadastro",
    path: cadastroykWxkkxImXMeta?.path ?? "/categorias-de-materiais/cadastro",
    meta: cadastroykWxkkxImXMeta || {},
    alias: cadastroykWxkkxImXMeta?.alias || [],
    redirect: cadastroykWxkkxImXMeta?.redirect || undefined,
    component: () => import("/opt/buildhome/repo/pages/categorias-de-materiais/cadastro.vue").then(m => m.default || m)
  },
  {
    name: indexP6UC4cgrz4Meta?.name ?? "categorias-de-materiais",
    path: indexP6UC4cgrz4Meta?.path ?? "/categorias-de-materiais",
    meta: indexP6UC4cgrz4Meta || {},
    alias: indexP6UC4cgrz4Meta?.alias || [],
    redirect: indexP6UC4cgrz4Meta?.redirect || undefined,
    component: () => import("/opt/buildhome/repo/pages/categorias-de-materiais/index.vue").then(m => m.default || m)
  },
  {
    name: indexP00IrjAIc9Meta?.name ?? "configuracao",
    path: indexP00IrjAIc9Meta?.path ?? "/configuracao",
    meta: indexP00IrjAIc9Meta || {},
    alias: indexP00IrjAIc9Meta?.alias || [],
    redirect: indexP00IrjAIc9Meta?.redirect || undefined,
    component: () => import("/opt/buildhome/repo/pages/configuracao/index.vue").then(m => m.default || m)
  },
  {
    name: indexbI1Frn8FgaMeta?.name ?? "dispensacao-de-materiais",
    path: indexbI1Frn8FgaMeta?.path ?? "/dispensacao-de-materiais",
    meta: indexbI1Frn8FgaMeta || {},
    alias: indexbI1Frn8FgaMeta?.alias || [],
    redirect: indexbI1Frn8FgaMeta?.redirect || undefined,
    component: () => import("/opt/buildhome/repo/pages/dispensacao-de-materiais/index.vue").then(m => m.default || m)
  },
  {
    name: nova_45dispensacao6JiT52hiyKMeta?.name ?? "dispensacao-de-materiais-nova-dispensacao",
    path: nova_45dispensacao6JiT52hiyKMeta?.path ?? "/dispensacao-de-materiais/nova-dispensacao",
    meta: nova_45dispensacao6JiT52hiyKMeta || {},
    alias: nova_45dispensacao6JiT52hiyKMeta?.alias || [],
    redirect: nova_45dispensacao6JiT52hiyKMeta?.redirect || undefined,
    component: () => import("/opt/buildhome/repo/pages/dispensacao-de-materiais/nova-dispensacao.vue").then(m => m.default || m)
  },
  {
    name: indexyozOxF5mlSMeta?.name ?? "emitir-guia-de-exames",
    path: indexyozOxF5mlSMeta?.path ?? "/emitir-guia-de-exames",
    meta: indexyozOxF5mlSMeta || {},
    alias: indexyozOxF5mlSMeta?.alias || [],
    redirect: indexyozOxF5mlSMeta?.redirect || undefined,
    component: () => import("/opt/buildhome/repo/pages/emitir-guia-de-exames/index.vue").then(m => m.default || m)
  },
  {
    name: index9vmmfV6bwsMeta?.name ?? "entrada-de-materiais",
    path: index9vmmfV6bwsMeta?.path ?? "/entrada-de-materiais",
    meta: index9vmmfV6bwsMeta || {},
    alias: index9vmmfV6bwsMeta?.alias || [],
    redirect: index9vmmfV6bwsMeta?.redirect || undefined,
    component: () => import("/opt/buildhome/repo/pages/entrada-de-materiais/index.vue").then(m => m.default || m)
  },
  {
    name: nova_45entradafnxban9NQVMeta?.name ?? "entrada-de-materiais-nova-entrada",
    path: nova_45entradafnxban9NQVMeta?.path ?? "/entrada-de-materiais/nova-entrada",
    meta: nova_45entradafnxban9NQVMeta || {},
    alias: nova_45entradafnxban9NQVMeta?.alias || [],
    redirect: nova_45entradafnxban9NQVMeta?.redirect || undefined,
    component: () => import("/opt/buildhome/repo/pages/entrada-de-materiais/nova-entrada.vue").then(m => m.default || m)
  },
  {
    name: _91id_93adHz4MhA2uMeta?.name ?? "exames-alteracao-id",
    path: _91id_93adHz4MhA2uMeta?.path ?? "/exames/alteracao/:id()",
    meta: _91id_93adHz4MhA2uMeta || {},
    alias: _91id_93adHz4MhA2uMeta?.alias || [],
    redirect: _91id_93adHz4MhA2uMeta?.redirect || undefined,
    component: () => import("/opt/buildhome/repo/pages/exames/alteracao/[id].vue").then(m => m.default || m)
  },
  {
    name: cadastroWBn9S2vhMYMeta?.name ?? "exames-cadastro",
    path: cadastroWBn9S2vhMYMeta?.path ?? "/exames/cadastro",
    meta: cadastroWBn9S2vhMYMeta || {},
    alias: cadastroWBn9S2vhMYMeta?.alias || [],
    redirect: cadastroWBn9S2vhMYMeta?.redirect || undefined,
    component: () => import("/opt/buildhome/repo/pages/exames/cadastro.vue").then(m => m.default || m)
  },
  {
    name: indexhCXvGcN4UaMeta?.name ?? "exames",
    path: indexhCXvGcN4UaMeta?.path ?? "/exames",
    meta: indexhCXvGcN4UaMeta || {},
    alias: indexhCXvGcN4UaMeta?.alias || [],
    redirect: indexhCXvGcN4UaMeta?.redirect || undefined,
    component: () => import("/opt/buildhome/repo/pages/exames/index.vue").then(m => m.default || m)
  },
  {
    name: _91categoria_93yHbg8CLBZYMeta?.name ?? "exames-por-categoria-categoria",
    path: _91categoria_93yHbg8CLBZYMeta?.path ?? "/exames/por-categoria/:categoria()",
    meta: _91categoria_93yHbg8CLBZYMeta || {},
    alias: _91categoria_93yHbg8CLBZYMeta?.alias || [],
    redirect: _91categoria_93yHbg8CLBZYMeta?.redirect || undefined,
    component: () => import("/opt/buildhome/repo/pages/exames/por-categoria/[categoria].vue").then(m => m.default || m)
  },
  {
    name: _91id_93KktXbnEv4EMeta?.name ?? "fornecedores-alteracao-id",
    path: _91id_93KktXbnEv4EMeta?.path ?? "/fornecedores/alteracao/:id()",
    meta: _91id_93KktXbnEv4EMeta || {},
    alias: _91id_93KktXbnEv4EMeta?.alias || [],
    redirect: _91id_93KktXbnEv4EMeta?.redirect || undefined,
    component: () => import("/opt/buildhome/repo/pages/fornecedores/alteracao/[id].vue").then(m => m.default || m)
  },
  {
    name: cadastroz74fvs7IDFMeta?.name ?? "fornecedores-cadastro",
    path: cadastroz74fvs7IDFMeta?.path ?? "/fornecedores/cadastro",
    meta: cadastroz74fvs7IDFMeta || {},
    alias: cadastroz74fvs7IDFMeta?.alias || [],
    redirect: cadastroz74fvs7IDFMeta?.redirect || undefined,
    component: () => import("/opt/buildhome/repo/pages/fornecedores/cadastro.vue").then(m => m.default || m)
  },
  {
    name: indexPRIS4gOa4DMeta?.name ?? "fornecedores",
    path: indexPRIS4gOa4DMeta?.path ?? "/fornecedores",
    meta: indexPRIS4gOa4DMeta || {},
    alias: indexPRIS4gOa4DMeta?.alias || [],
    redirect: indexPRIS4gOa4DMeta?.redirect || undefined,
    component: () => import("/opt/buildhome/repo/pages/fornecedores/index.vue").then(m => m.default || m)
  },
  {
    name: _91id_93JSziduNObqMeta?.name ?? "funcoes-alteracao-id",
    path: _91id_93JSziduNObqMeta?.path ?? "/funcoes/alteracao/:id()",
    meta: _91id_93JSziduNObqMeta || {},
    alias: _91id_93JSziduNObqMeta?.alias || [],
    redirect: _91id_93JSziduNObqMeta?.redirect || undefined,
    component: () => import("/opt/buildhome/repo/pages/funcoes/alteracao/[id].vue").then(m => m.default || m)
  },
  {
    name: cadastrox0hzuIXObsMeta?.name ?? "funcoes-cadastro",
    path: cadastrox0hzuIXObsMeta?.path ?? "/funcoes/cadastro",
    meta: cadastrox0hzuIXObsMeta || {},
    alias: cadastrox0hzuIXObsMeta?.alias || [],
    redirect: cadastrox0hzuIXObsMeta?.redirect || undefined,
    component: () => import("/opt/buildhome/repo/pages/funcoes/cadastro.vue").then(m => m.default || m)
  },
  {
    name: index84J9OY2pqdMeta?.name ?? "funcoes",
    path: index84J9OY2pqdMeta?.path ?? "/funcoes",
    meta: index84J9OY2pqdMeta || {},
    alias: index84J9OY2pqdMeta?.alias || [],
    redirect: index84J9OY2pqdMeta?.redirect || undefined,
    component: () => import("/opt/buildhome/repo/pages/funcoes/index.vue").then(m => m.default || m)
  },
  {
    name: indexwT1xCr0TuOMeta?.name ?? "gerenciar-estoque",
    path: indexwT1xCr0TuOMeta?.path ?? "/gerenciar-estoque",
    meta: indexwT1xCr0TuOMeta || {},
    alias: indexwT1xCr0TuOMeta?.alias || [],
    redirect: indexwT1xCr0TuOMeta?.redirect || undefined,
    component: () => import("/opt/buildhome/repo/pages/gerenciar-estoque/index.vue").then(m => m.default || m)
  },
  {
    name: indexniDiYCWjuTMeta?.name ?? "index",
    path: indexniDiYCWjuTMeta?.path ?? "/",
    meta: indexniDiYCWjuTMeta || {},
    alias: indexniDiYCWjuTMeta?.alias || [],
    redirect: indexniDiYCWjuTMeta?.redirect || undefined,
    component: () => import("/opt/buildhome/repo/pages/index.vue").then(m => m.default || m)
  },
  {
    name: indexmOLpqkzYT7Meta?.name ?? "liberacao-de-exames",
    path: indexmOLpqkzYT7Meta?.path ?? "/liberacao-de-exames",
    meta: indexmOLpqkzYT7Meta || {},
    alias: indexmOLpqkzYT7Meta?.alias || [],
    redirect: indexmOLpqkzYT7Meta?.redirect || undefined,
    component: () => import("/opt/buildhome/repo/pages/liberacao-de-exames/index.vue").then(m => m.default || m)
  },
  {
    name: _91id_93kdnSCYCUJ4Meta?.name ?? "materiais-alteracao-id",
    path: _91id_93kdnSCYCUJ4Meta?.path ?? "/materiais/alteracao/:id()",
    meta: _91id_93kdnSCYCUJ4Meta || {},
    alias: _91id_93kdnSCYCUJ4Meta?.alias || [],
    redirect: _91id_93kdnSCYCUJ4Meta?.redirect || undefined,
    component: () => import("/opt/buildhome/repo/pages/materiais/alteracao/[id].vue").then(m => m.default || m)
  },
  {
    name: cadastrotAM87ZAJziMeta?.name ?? "materiais-cadastro",
    path: cadastrotAM87ZAJziMeta?.path ?? "/materiais/cadastro",
    meta: cadastrotAM87ZAJziMeta || {},
    alias: cadastrotAM87ZAJziMeta?.alias || [],
    redirect: cadastrotAM87ZAJziMeta?.redirect || undefined,
    component: () => import("/opt/buildhome/repo/pages/materiais/cadastro.vue").then(m => m.default || m)
  },
  {
    name: indexQybCB9a9LQMeta?.name ?? "materiais",
    path: indexQybCB9a9LQMeta?.path ?? "/materiais",
    meta: indexQybCB9a9LQMeta || {},
    alias: indexQybCB9a9LQMeta?.alias || [],
    redirect: indexQybCB9a9LQMeta?.redirect || undefined,
    component: () => import("/opt/buildhome/repo/pages/materiais/index.vue").then(m => m.default || m)
  },
  {
    name: _91id_93Xet1u3s5jIMeta?.name ?? "medicos-alteracao-id",
    path: _91id_93Xet1u3s5jIMeta?.path ?? "/medicos/alteracao/:id()",
    meta: _91id_93Xet1u3s5jIMeta || {},
    alias: _91id_93Xet1u3s5jIMeta?.alias || [],
    redirect: _91id_93Xet1u3s5jIMeta?.redirect || undefined,
    component: () => import("/opt/buildhome/repo/pages/medicos/alteracao/[id].vue").then(m => m.default || m)
  },
  {
    name: cadastroMxTSQLnK8UMeta?.name ?? "medicos-cadastro",
    path: cadastroMxTSQLnK8UMeta?.path ?? "/medicos/cadastro",
    meta: cadastroMxTSQLnK8UMeta || {},
    alias: cadastroMxTSQLnK8UMeta?.alias || [],
    redirect: cadastroMxTSQLnK8UMeta?.redirect || undefined,
    component: () => import("/opt/buildhome/repo/pages/medicos/cadastro.vue").then(m => m.default || m)
  },
  {
    name: indexW9o7jSLWaYMeta?.name ?? "medicos",
    path: indexW9o7jSLWaYMeta?.path ?? "/medicos",
    meta: indexW9o7jSLWaYMeta || {},
    alias: indexW9o7jSLWaYMeta?.alias || [],
    redirect: indexW9o7jSLWaYMeta?.redirect || undefined,
    component: () => import("/opt/buildhome/repo/pages/medicos/index.vue").then(m => m.default || m)
  },
  {
    name: _91id_93CALT9J3AWjMeta?.name ?? "pacientes-alteracao-id",
    path: _91id_93CALT9J3AWjMeta?.path ?? "/pacientes/alteracao/:id()",
    meta: _91id_93CALT9J3AWjMeta || {},
    alias: _91id_93CALT9J3AWjMeta?.alias || [],
    redirect: _91id_93CALT9J3AWjMeta?.redirect || undefined,
    component: () => import("/opt/buildhome/repo/pages/pacientes/alteracao/[id].vue").then(m => m.default || m)
  },
  {
    name: cadastro5iOlbfBY00Meta?.name ?? "pacientes-cadastro",
    path: cadastro5iOlbfBY00Meta?.path ?? "/pacientes/cadastro",
    meta: cadastro5iOlbfBY00Meta || {},
    alias: cadastro5iOlbfBY00Meta?.alias || [],
    redirect: cadastro5iOlbfBY00Meta?.redirect || undefined,
    component: () => import("/opt/buildhome/repo/pages/pacientes/cadastro.vue").then(m => m.default || m)
  },
  {
    name: indexCPUJtqEjFHMeta?.name ?? "pacientes",
    path: indexCPUJtqEjFHMeta?.path ?? "/pacientes",
    meta: indexCPUJtqEjFHMeta || {},
    alias: indexCPUJtqEjFHMeta?.alias || [],
    redirect: indexCPUJtqEjFHMeta?.redirect || undefined,
    component: () => import("/opt/buildhome/repo/pages/pacientes/index.vue").then(m => m.default || m)
  },
  {
    name: _91id_93cxnaEKkCy2Meta?.name ?? "programas-alteracao-id",
    path: _91id_93cxnaEKkCy2Meta?.path ?? "/programas/alteracao/:id()",
    meta: _91id_93cxnaEKkCy2Meta || {},
    alias: _91id_93cxnaEKkCy2Meta?.alias || [],
    redirect: _91id_93cxnaEKkCy2Meta?.redirect || undefined,
    component: () => import("/opt/buildhome/repo/pages/programas/alteracao/[id].vue").then(m => m.default || m)
  },
  {
    name: cadastroIVQoiJTJBDMeta?.name ?? "programas-cadastro",
    path: cadastroIVQoiJTJBDMeta?.path ?? "/programas/cadastro",
    meta: cadastroIVQoiJTJBDMeta || {},
    alias: cadastroIVQoiJTJBDMeta?.alias || [],
    redirect: cadastroIVQoiJTJBDMeta?.redirect || undefined,
    component: () => import("/opt/buildhome/repo/pages/programas/cadastro.vue").then(m => m.default || m)
  },
  {
    name: indexlvytRUSfTgMeta?.name ?? "programas",
    path: indexlvytRUSfTgMeta?.path ?? "/programas",
    meta: indexlvytRUSfTgMeta || {},
    alias: indexlvytRUSfTgMeta?.alias || [],
    redirect: indexlvytRUSfTgMeta?.redirect || undefined,
    component: () => import("/opt/buildhome/repo/pages/programas/index.vue").then(m => m.default || m)
  },
  {
    name: examesFkgIdDrvv6Meta?.name ?? "relatorios-exames",
    path: examesFkgIdDrvv6Meta?.path ?? "/relatorios/exames",
    meta: examesFkgIdDrvv6Meta || {},
    alias: examesFkgIdDrvv6Meta?.alias || [],
    redirect: examesFkgIdDrvv6Meta?.redirect || undefined,
    component: () => import("/opt/buildhome/repo/pages/relatorios/exames.vue").then(m => m.default || m)
  },
  {
    name: historico_45do_45pacientejVcuLBjescMeta?.name ?? "relatorios-historico-do-paciente",
    path: historico_45do_45pacientejVcuLBjescMeta?.path ?? "/relatorios/historico-do-paciente",
    meta: historico_45do_45pacientejVcuLBjescMeta || {},
    alias: historico_45do_45pacientejVcuLBjescMeta?.alias || [],
    redirect: historico_45do_45pacientejVcuLBjescMeta?.redirect || undefined,
    component: () => import("/opt/buildhome/repo/pages/relatorios/historico-do-paciente.vue").then(m => m.default || m)
  },
  {
    name: log_45acoes_45do_45usuario5YH6nwnxqvMeta?.name ?? "relatorios-log-acoes-do-usuario",
    path: log_45acoes_45do_45usuario5YH6nwnxqvMeta?.path ?? "/relatorios/log-acoes-do-usuario",
    meta: log_45acoes_45do_45usuario5YH6nwnxqvMeta || {},
    alias: log_45acoes_45do_45usuario5YH6nwnxqvMeta?.alias || [],
    redirect: log_45acoes_45do_45usuario5YH6nwnxqvMeta?.redirect || undefined,
    component: () => import("/opt/buildhome/repo/pages/relatorios/log-acoes-do-usuario.vue").then(m => m.default || m)
  },
  {
    name: indexA0VPeroZ6FMeta?.name ?? "solicitacoes-de-exames",
    path: indexA0VPeroZ6FMeta?.path ?? "/solicitacoes-de-exames",
    meta: indexA0VPeroZ6FMeta || {},
    alias: indexA0VPeroZ6FMeta?.alias || [],
    redirect: indexA0VPeroZ6FMeta?.redirect || undefined,
    component: () => import("/opt/buildhome/repo/pages/solicitacoes-de-exames/index.vue").then(m => m.default || m)
  },
  {
    name: novae4aRbU80uhMeta?.name ?? "solicitacoes-de-exames-nova",
    path: novae4aRbU80uhMeta?.path ?? "/solicitacoes-de-exames/nova",
    meta: novae4aRbU80uhMeta || {},
    alias: novae4aRbU80uhMeta?.alias || [],
    redirect: novae4aRbU80uhMeta?.redirect || undefined,
    component: () => import("/opt/buildhome/repo/pages/solicitacoes-de-exames/nova.vue").then(m => m.default || m)
  },
  {
    name: old_gerenciahKUd9GBye4Meta?.name ?? "solicitacoes-de-exames-old_gerencia",
    path: old_gerenciahKUd9GBye4Meta?.path ?? "/solicitacoes-de-exames/old_gerencia",
    meta: old_gerenciahKUd9GBye4Meta || {},
    alias: old_gerenciahKUd9GBye4Meta?.alias || [],
    redirect: old_gerenciahKUd9GBye4Meta?.redirect || undefined,
    component: () => import("/opt/buildhome/repo/pages/solicitacoes-de-exames/old_gerencia.vue").then(m => m.default || m)
  },
  {
    name: _91id_93T01U1W3gg5Meta?.name ?? "solicitacoes-de-exames-old_gerenciar-id",
    path: _91id_93T01U1W3gg5Meta?.path ?? "/solicitacoes-de-exames/old_gerenciar/:id()",
    meta: _91id_93T01U1W3gg5Meta || {},
    alias: _91id_93T01U1W3gg5Meta?.alias || [],
    redirect: _91id_93T01U1W3gg5Meta?.redirect || undefined,
    component: () => import("/opt/buildhome/repo/pages/solicitacoes-de-exames/old_gerenciar/[id].vue").then(m => m.default || m)
  },
  {
    name: index3VTqskQBowMeta?.name ?? "transferencia-de-materiais",
    path: index3VTqskQBowMeta?.path ?? "/transferencia-de-materiais",
    meta: index3VTqskQBowMeta || {},
    alias: index3VTqskQBowMeta?.alias || [],
    redirect: index3VTqskQBowMeta?.redirect || undefined,
    component: () => import("/opt/buildhome/repo/pages/transferencia-de-materiais/index.vue").then(m => m.default || m)
  },
  {
    name: nova_45transferenciaX1TPUx1X2vMeta?.name ?? "transferencia-de-materiais-nova-transferencia",
    path: nova_45transferenciaX1TPUx1X2vMeta?.path ?? "/transferencia-de-materiais/nova-transferencia",
    meta: nova_45transferenciaX1TPUx1X2vMeta || {},
    alias: nova_45transferenciaX1TPUx1X2vMeta?.alias || [],
    redirect: nova_45transferenciaX1TPUx1X2vMeta?.redirect || undefined,
    component: () => import("/opt/buildhome/repo/pages/transferencia-de-materiais/nova-transferencia.vue").then(m => m.default || m)
  },
  {
    name: _91situacao_93Da26bWbqdPMeta?.name ?? "transferencia-de-materiais-por-situacao-situacao",
    path: _91situacao_93Da26bWbqdPMeta?.path ?? "/transferencia-de-materiais/por-situacao/:situacao()",
    meta: _91situacao_93Da26bWbqdPMeta || {},
    alias: _91situacao_93Da26bWbqdPMeta?.alias || [],
    redirect: _91situacao_93Da26bWbqdPMeta?.redirect || undefined,
    component: () => import("/opt/buildhome/repo/pages/transferencia-de-materiais/por-situacao/[situacao].vue").then(m => m.default || m)
  },
  {
    name: _91id_93ONK0M37MY1Meta?.name ?? "unidades-de-materiais-alteracao-id",
    path: _91id_93ONK0M37MY1Meta?.path ?? "/unidades-de-materiais/alteracao/:id()",
    meta: _91id_93ONK0M37MY1Meta || {},
    alias: _91id_93ONK0M37MY1Meta?.alias || [],
    redirect: _91id_93ONK0M37MY1Meta?.redirect || undefined,
    component: () => import("/opt/buildhome/repo/pages/unidades-de-materiais/alteracao/[id].vue").then(m => m.default || m)
  },
  {
    name: cadastroJu80IlOM9CMeta?.name ?? "unidades-de-materiais-cadastro",
    path: cadastroJu80IlOM9CMeta?.path ?? "/unidades-de-materiais/cadastro",
    meta: cadastroJu80IlOM9CMeta || {},
    alias: cadastroJu80IlOM9CMeta?.alias || [],
    redirect: cadastroJu80IlOM9CMeta?.redirect || undefined,
    component: () => import("/opt/buildhome/repo/pages/unidades-de-materiais/cadastro.vue").then(m => m.default || m)
  },
  {
    name: indexXfL2oT74KGMeta?.name ?? "unidades-de-materiais",
    path: indexXfL2oT74KGMeta?.path ?? "/unidades-de-materiais",
    meta: indexXfL2oT74KGMeta || {},
    alias: indexXfL2oT74KGMeta?.alias || [],
    redirect: indexXfL2oT74KGMeta?.redirect || undefined,
    component: () => import("/opt/buildhome/repo/pages/unidades-de-materiais/index.vue").then(m => m.default || m)
  },
  {
    name: _91id_9311TPqFmMvlMeta?.name ?? "unidades-medicas-alteracao-id",
    path: _91id_9311TPqFmMvlMeta?.path ?? "/unidades-medicas/alteracao/:id()",
    meta: _91id_9311TPqFmMvlMeta || {},
    alias: _91id_9311TPqFmMvlMeta?.alias || [],
    redirect: _91id_9311TPqFmMvlMeta?.redirect || undefined,
    component: () => import("/opt/buildhome/repo/pages/unidades-medicas/alteracao/[id].vue").then(m => m.default || m)
  },
  {
    name: cadastrom74EvGEjNwMeta?.name ?? "unidades-medicas-cadastro",
    path: cadastrom74EvGEjNwMeta?.path ?? "/unidades-medicas/cadastro",
    meta: cadastrom74EvGEjNwMeta || {},
    alias: cadastrom74EvGEjNwMeta?.alias || [],
    redirect: cadastrom74EvGEjNwMeta?.redirect || undefined,
    component: () => import("/opt/buildhome/repo/pages/unidades-medicas/cadastro.vue").then(m => m.default || m)
  },
  {
    name: indexXRm9hNsHyZMeta?.name ?? "unidades-medicas",
    path: indexXRm9hNsHyZMeta?.path ?? "/unidades-medicas",
    meta: indexXRm9hNsHyZMeta || {},
    alias: indexXRm9hNsHyZMeta?.alias || [],
    redirect: indexXRm9hNsHyZMeta?.redirect || undefined,
    component: () => import("/opt/buildhome/repo/pages/unidades-medicas/index.vue").then(m => m.default || m)
  },
  {
    name: _91id_938tjudblfUbMeta?.name ?? "usuarios-alteracao-id",
    path: _91id_938tjudblfUbMeta?.path ?? "/usuarios/alteracao/:id()",
    meta: _91id_938tjudblfUbMeta || {},
    alias: _91id_938tjudblfUbMeta?.alias || [],
    redirect: _91id_938tjudblfUbMeta?.redirect || undefined,
    component: () => import("/opt/buildhome/repo/pages/usuarios/alteracao/[id].vue").then(m => m.default || m)
  },
  {
    name: alterar_45dados_45de_45acessoLqwh1HZbzKMeta?.name ?? "usuarios-alterar-dados-de-acesso",
    path: alterar_45dados_45de_45acessoLqwh1HZbzKMeta?.path ?? "/usuarios/alterar-dados-de-acesso",
    meta: alterar_45dados_45de_45acessoLqwh1HZbzKMeta || {},
    alias: alterar_45dados_45de_45acessoLqwh1HZbzKMeta?.alias || [],
    redirect: alterar_45dados_45de_45acessoLqwh1HZbzKMeta?.redirect || undefined,
    component: () => import("/opt/buildhome/repo/pages/usuarios/alterar-dados-de-acesso.vue").then(m => m.default || m)
  },
  {
    name: alterar_45meus_45dadosGsBABu4vyOMeta?.name ?? "usuarios-alterar-meus-dados",
    path: alterar_45meus_45dadosGsBABu4vyOMeta?.path ?? "/usuarios/alterar-meus-dados",
    meta: alterar_45meus_45dadosGsBABu4vyOMeta || {},
    alias: alterar_45meus_45dadosGsBABu4vyOMeta?.alias || [],
    redirect: alterar_45meus_45dadosGsBABu4vyOMeta?.redirect || undefined,
    component: () => import("/opt/buildhome/repo/pages/usuarios/alterar-meus-dados.vue").then(m => m.default || m)
  },
  {
    name: cadastro1cqvz05gobMeta?.name ?? "usuarios-cadastro",
    path: cadastro1cqvz05gobMeta?.path ?? "/usuarios/cadastro",
    meta: cadastro1cqvz05gobMeta || {},
    alias: cadastro1cqvz05gobMeta?.alias || [],
    redirect: cadastro1cqvz05gobMeta?.redirect || undefined,
    component: () => import("/opt/buildhome/repo/pages/usuarios/cadastro.vue").then(m => m.default || m)
  },
  {
    name: indexJvDD2TXhs0Meta?.name ?? "usuarios",
    path: indexJvDD2TXhs0Meta?.path ?? "/usuarios",
    meta: indexJvDD2TXhs0Meta || {},
    alias: indexJvDD2TXhs0Meta?.alias || [],
    redirect: indexJvDD2TXhs0Meta?.redirect || undefined,
    component: () => import("/opt/buildhome/repo/pages/usuarios/index.vue").then(m => m.default || m)
  }
]